import { gql } from "@apollo/client";

import { vcsIntegrationDetailsFragment } from "../VcsShared/gql";

export const SEARCH_VCS_INTEGRATIONS = gql`
  ${vcsIntegrationDetailsFragment}
  query SearchVCSIntegrations2(
    $input: SearchInput!
    $searchUsersSuggestionsInput: SearchSuggestionsInput!
  ) {
    providers
    searchVCSIntegrations(input: $input) {
      edges {
        cursor
        node {
          id
          name
          labels
          description
          provider
          isDefault
          space {
            id
            name
            accessLevel
          }
          searchUsersSuggestions(input: $searchUsersSuggestionsInput) {
            filteredCount
          }
          ...vcsIntegrationDetails
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_DEFAULT_VCS_INTEGRATIONS = gql`
  query GetDefaultVCSIntegrations {
    searchVCSIntegrations(
      input: { predicates: [{ field: "is_default", constraint: { booleanEquals: [true] } }] }
    ) {
      edges {
        node {
          id
          provider
        }
      }
    }
  }
`;
